var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"8337e430e228861c10697bb8c3869a2166f7da63"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["yapdomik-frontend-website@sushi-market"]={id:"8337e430e228861c10697bb8c3869a2166f7da63"};
      